import { getTenantConfig } from 'Utils';

// grabs the specific language/country translation as well as returns english as the baseline default
// note: this won't work for any country specific english
const getTranslation = (translations, language, country) => {
  const translation = {
    en: translations.en,
  };

  if (language !== 'en') {
    translation[language] =
      translations[`${language}-${country}`] || translations[language];
  }

  return translation;
};

/**
 * return the appropriate text when accepting terms
 * @param strings - translations object for current language
 * @param country - user's country
 * @param existingUser - true if user already exists, false otherwise
 * @returns {string} - text to display
 */
export const getAcceptTermsText = (
  strings = {},
  country = 'US',
  existingUser = false
) => {
  if (country === 'US' && getTenantConfig().overrideAcceptTermsText) {
    return 'Agree & Continue';
  }

  if (existingUser) {
    return strings.continue;
  }

  return strings.createAccount;
};

// adds String.format function so we can inject values into UIMs __arg0__ format
if (!String.prototype.formatUimTranslation) {
  String.prototype.formatUimTranslation = function () {
    var args = arguments;
    return this.replace(/__arg(\d+)__/g, function (match, number) {
      return typeof args[number] != 'undefined' ? args[number] : match;
    });
  };

  String.prototype.formatUimTranslationLink = function (field, link) {
    return this.replace(/__arg(\d+)__/g, function (match, number) {
      return field && link ? `<a href=${link}>${field}</a>` : match;
    });
  };
}

export { getTranslation };
